import type { ShipmentFieldsVisibilityResponse } from './api';

export const normalizeShipmentFieldsVisibility = (list: ShipmentFieldsVisibilityResponse): Record<string, boolean> => {
  if (!list) {
    return {};
  }
  return Object.fromEntries(list.map((item) => [item.columnName, !!item.isVisible]));
};
